<div id="fabbutton" [style.background-color]="color" [style.bottom]="bottom" [style.right]="right">
    <div
        class="icon"
        [style.background-image]="'url(/assets/icons/' + icon + ')'"
    ></div>
</div>
